import Swiper from './slideshows/swiper-setup';
import $ from 'jquery';

const NOT_LOADED = 1;
const LOADING = 2;
const LOADED = 3;

$(_ => {

  const $cal = $('#mini-cal');
  if ($cal.length === 0) return;

  /** Slideshow setup */

  const $doc = $(document);
  const prod = $cal.attr('data-mc-filtering-prod');

  let startIndex = 0;
  const slides = $.map($doc.find('.js-mc-slide'), (el, index) => {

    const state = el.hasAttribute('data-mc-start-month') ? LOADED : NOT_LOADED;

    if (state === LOADED) {
      startIndex = index;
    }

    return { state, el };
  });

  new Swiper ($cal[0], {
    loop: false,
    initialSlide: startIndex,
    prevButton: '.ss__btn-page--prev',
    nextButton: '.ss__btn-page--next',
    slideClass: 'js-mc-slide',
    wrapperClass: 'ss__slides',
    onSlideChangeEnd: (swiper) => {

      const slide = slides[swiper.activeIndex];
      if (slide.state === NOT_LOADED) {
        slide.state = LOADING;

        const $el = $(slide.el);
        const month = $el.attr('data-mc-month');

        $.get('/h/events/CalendarMiniMonth', {month, prod}).done(res => {
          slide.state = LOADED;
          window.requestAnimationFrame(_ => {
            const $new = $(res.data.html);
            $new.addClass('mc__table--newly-inserted');
            $el.find('.js-mc-month-placeholder').replaceWith($new);

            window.requestAnimationFrame(_ => {
              $new.removeClass('mc__table--newly-inserted');
            });

          });
        });

      }
    }
  });


  /** Popover setup */

  const popoverMap = new Map();
  const $popoverContainer = $('#mini-cal-popover-container');

  $cal.on('click', '.js-mini-cal-date', event => {

    const btn = event.currentTarget;
    let $btn;
    let $popover;

    if (popoverMap.has(btn)) {
      ({$popover, $btn} = popoverMap.get(btn));
    } else {
      $btn = $(event.currentTarget);
      const date = $btn.attr('data-mini-cal-date');
      $popover = $cal.find(`.js-mini-cal-popover[data-mini-cal-date=${date}]`);
      popoverMap.set(btn, {$popover, $btn});

      const pos = $btn.position();


      $popoverContainer.append($popover);
      $popover.css({
        top: Math.round(pos.top),
        left: Math.round(pos.left)
      });
    }

    $popover.fadeIn({ duration: 200 });

    const onClick = event => {

      if (
        event.target === $btn[0] ||
        event.target === $popover[0] ||
        $.contains($popover[0], event.target)
      ) {
        return;
      } else {
        $popover.hide();
        $doc.off('click', onClick);
      }
    };

    window.setTimeout(_ => {
      $doc.on('touchstart mousedown', onClick);
    }, 1);

  });

  $( ".js-minical-close" ).each(function( index, el ) {
      $(el).click(function(el) {
        $( ".js-mini-cal-popover" ).each(function( index, el ) {
            $(el).css("display", "none");
        });
      });
  });

});


